import { render } from "./gamesTab.vue?vue&type=template&id=b6e6ae82&scoped=true"
import script from "./gamesTab.vue?vue&type=script&lang=js"
export * from "./gamesTab.vue?vue&type=script&lang=js"

import "./gamesTab.vue?vue&type=style&index=0&id=b6e6ae82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e6ae82"]])

export default __exports__